import { Route, Navigate } from 'react-router-dom'

import Dashboard from '../pages/Dashboard'

import ProtectedRoute from '../components/ProtectedRoute'

import {

  SystemAdminDashboard, ApprovalInbox, SystemRulesPage, ApprovalKitAdminPage, ApprovalKitInboxPage, ApprovalRoute, NotificationCenter,

  RiskMonitorDashboard, PartnerOperationsPage, AuditLogPage, MoldDeveloperDashboard, MakerDashboard,

  PlantDashboard, MakerMobileDashboard, PlantMobileDashboard, DeveloperMobileDashboard,

  MoldList, MoldNew, MoldRegistration, MoldBulkUpload, MoldMaster, MoldLifecycle,

  MoldDetailNew, MoldDocuments, MoldPhotoGallery,

  DailyChecklist, PeriodicInspection, InspectionApproval, ChecklistMaster, MoldChecklist,

  TransferManagement, TransferRequest, RepairManagement, RepairRequestForm,

  RepairShipmentChecklist, HqRepairListPage, MakerRepairListPage, MoldRepairHistory, MoldTransferHistory, MoldInspectionHistory, MakerMoldDetail,

  MoldDevelopmentPlan, MoldNurturingPage, MoldNurturingOverview, HardnessMeasurement, MoldSpecification,
  MoldingAnalysis,
  MoldInvestment,

  InjectionHistory, InjectionStats, InjectionCondition,

  CompanyManagement, CompanyDetail, CompanyProfile, PartnerInjectionSummary, PartnerEquipmentSummary, PartnerPaintLineSummary,

  PlantMoldSelect, UserRequests, InternalUsers, PartnerUsers, MasterData,
  InspectionGuideMaster,

  MoldWorkflowManagement, Alerts, ScrappingManagement, MoldScrappingProgress, MaintenanceManagement,

  NotificationSettings, Reports, MoldHistory, MoldQRCode, QRSessionsPage,

  // 2026-07-08 orphan 정리: PC 배선 복원 (모바일 페어는 기 라우팅)
  InspectionDueMoldListPage, OverShotMoldListPage,

  MoldLocationMapPage, StandardDocumentMaster, ProductionTransferChecklistMaster,
  ProductionTransferChecklist,

  // Phase D — PC 파리티 신규
  GlobalSearch, MoldTryoutIssue, Board,
  // Phase G-2: Task Center
  TaskCenter,
  // Phase H-D: 메뉴 권한 관리
  MenuPermissionsPage,
  // 협력사 초기화 + 일괄 등록
  SeedCompaniesPage, ReactivateCompaniesPage, MergeCompaniesPage, ImageCleanupPage, PasswordSecurityPage, PartnerFinancePage,
  AssetAuditPage, AssetAuditDetailPage, AsMoldRegistryPage,
  // 금형 초기화
  ResetMoldsPage,
  // Phase BM: 전체 금형 양산중 일괄 전환
  SetMoldsActivePage,
  // Phase I-2: 승인 템플릿 관리
  ApprovalTemplatesPage,
  // Phase K: 승인 위임
  DelegationsPage,
  // Phase 2.1: 통합 점검/유지보전
  MaintenanceTasksUnified,
  MaintenanceTaskNew,

  // 레거시: ChecklistMasterConsole, ChecklistMasterDetail, DocumentMasterConsole
  //         → 모두 StandardDocumentMaster 로 통합되어 Navigate 리다이렉트 처리됨
  AlertDetail,
} from './lazyRoutes'



/**

 * PC 라우트 (Layout 하위, 인증 필요)

 * App.jsx에서 {pcRoutes}로 삽입

 */

export const pcRoutes = [

  <Route key="pc-index" index element={<Dashboard />} />,

  /* 전역 검색 (MobileSearch PC 파리티) */
  <Route key="pc-search" path="search" element={<GlobalSearch />} />,

  /* 운영 게시판 (공지사항 / Q&A / 건의·개선요청) */
  <Route key="pc-board" path="board" element={<Board />} />,
  /* 2026-07-07: 알림 딥링크 /board/:id — 게시글 상세 자동 오픈 (라우트 없으면 blank) */
  <Route key="pc-board-detail" path="board/:id" element={<Board />} />,

  /* 초도T/O 이슈관리 (MobileTryoutIssue PC 파리티) */
  <Route key="pc-tryout" path="tryout-issues" element={<MoldTryoutIssue />} />,

  /* Phase G-2: Task Center */
  <Route key="pc-tasks" path="tasks" element={<TaskCenter />} />,

  /* Phase H-D: 메뉴 권한 관리 (system_admin 전용) */
  <Route key="pc-menu-perms" path="admin/menu-permissions" element={
    <ProtectedRoute allowedRoles={['system_admin']}><MenuPermissionsPage /></ProtectedRoute>
  } />,

  /* 협력사 초기화 + 일괄 등록 (system_admin 1회 작업) */
  <Route key="pc-seed-companies" path="admin/seed-companies" element={
    <ProtectedRoute allowedRoles={['system_admin']}><SeedCompaniesPage /></ProtectedRoute>
  } />,
  // 업체 통합(merge) — source 흡수 + 다공장 전환 (system_admin, dry_run + confirm)
  <Route key="pc-merge-companies" path="admin/merge-companies" element={
    <ProtectedRoute allowedRoles={['system_admin']}><MergeCompaniesPage /></ProtectedRoute>
  } />,
  <Route key="pc-image-cleanup" path="admin/image-cleanup" element={
    <ProtectedRoute allowedRoles={['system_admin']}><ImageCleanupPage /></ProtectedRoute>
  } />,
  // 초기 비밀번호(아이디와 동일) 사용 계정 현황 + 변경 요청 알림 (system_admin)
  <Route key="pc-password-security" path="admin/password-security" element={
    <ProtectedRoute allowedRoles={['system_admin']}><PasswordSecurityPage /></ProtectedRoute>
  } />,

  /* Phase FJ: 잘못 비활성화된 업체 일괄 재활성화 (system_admin) */
  <Route key="pc-reactivate-companies" path="admin/reactivate-companies" element={
    <ProtectedRoute allowedRoles={['system_admin']}><ReactivateCompaniesPage /></ProtectedRoute>
  } />,

  /* Phase BM: 전체 금형 양산중 일괄 전환 (system_admin 1회 작업) */
  <Route key="pc-set-molds-active" path="admin/set-molds-active" element={
    <ProtectedRoute allowedRoles={['system_admin']}><SetMoldsActivePage /></ProtectedRoute>
  } />,

  /* 금형 초기화 (system_admin) */
  <Route key="pc-reset-molds" path="admin/reset-molds" element={
    <ProtectedRoute allowedRoles={['system_admin']}><ResetMoldsPage /></ProtectedRoute>
  } />,

  /* Phase I-2: 승인 플로우 템플릿 관리 (system_admin 전용) */
  <Route key="pc-approval-templates" path="admin/approval-templates" element={
    <ProtectedRoute allowedRoles={['system_admin']}><ApprovalTemplatesPage /></ProtectedRoute>
  } />,

  /* Phase K: 승인 위임 (인증 사용자 전체) */
  <Route key="pc-delegations" path="delegations" element={
    <ProtectedRoute><DelegationsPage /></ProtectedRoute>
  } />,

  /* Phase 2.1: 통합 점검/유지보전 보기 */
  <Route key="pc-maintenance-tasks-unified" path="maintenance-tasks/unified" element={
    <ProtectedRoute><MaintenanceTasksUnified /></ProtectedRoute>
  } />,
  <Route key="pc-maintenance-tasks-new" path="maintenance-tasks/new" element={
    <ProtectedRoute><MaintenanceTaskNew /></ProtectedRoute>
  } />,

  /* 대시보드 */

  // Phase GK: 기본 system-admin 대시보드 admin/dev/staff 동등 접근 (메뉴는 user_type 별 분리)
  <Route key="pc-dash-admin" path="dashboard/system-admin" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><SystemAdminDashboard /></ProtectedRoute>} />,

  <Route key="pc-dash-dev" path="dashboard/mold-developer" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><MoldDeveloperDashboard /></ProtectedRoute>} />,

  <Route key="pc-dash-maker" path="dashboard/maker" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff', 'maker']}><MakerDashboard /></ProtectedRoute>} />,

  <Route key="pc-dash-plant" path="dashboard/plant" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff', 'plant']}><PlantDashboard /></ProtectedRoute>} />,

  /* 관리자 전용 */

  <Route key="pc-admin-appr" path="dashboard/system-admin/approvals" element={<ProtectedRoute allowedRoles={['system_admin']}><ApprovalInbox /></ProtectedRoute>} />,

  <Route key="pc-admin-rules" path="dashboard/system-admin/rules" element={<ProtectedRoute allowedRoles={['system_admin']}><SystemRulesPage /></ProtectedRoute>} />,

  <Route key="pc-admin-approval-kit" path="dashboard/system-admin/approval-kit" element={<ProtectedRoute allowedRoles={['system_admin']}><ApprovalKitAdminPage /></ProtectedRoute>} />,

  <Route key="pc-kit-inbox" path="approval-inbox" element={<ApprovalKitInboxPage />} />,

  <Route key="pc-approval-deeplink" path="approvals/:policyId/:targetId" element={<ApprovalRoute />} />,

  <Route key="pc-admin-notif" path="dashboard/system-admin/notifications" element={<ProtectedRoute allowedRoles={['system_admin']}><NotificationCenter /></ProtectedRoute>} />,

  // Phase JZ-104 M-1: 운영 모니터링 — Mobile 페어 (ADMIN_DEV_STAFF) 와 정합. mold_developer 메뉴 노출 ↔ 가드 일치
  <Route key="pc-admin-risk" path="dashboard/system-admin/risk-monitor" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><RiskMonitorDashboard /></ProtectedRoute>} />,
  <Route key="pc-partner-finance" path="partner-finance" element={
    <ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><PartnerFinancePage /></ProtectedRoute>
  } />,

  // 대여자산 실사 (SP-1) — 관리 화면은 본사 3역할 전용. 협력사 신고 동선은 모바일(/mobile/asset-audits)
  <Route key="pc-asset-audits" path="asset-audits" element={
    <ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><AssetAuditPage /></ProtectedRoute>
  } />,

  <Route key="pc-asset-audit-detail" path="asset-audits/:id" element={
    <ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><AssetAuditDetailPage /></ProtectedRoute>
  } />,

  // A/S 금형 대장 (SP-4) — 실사 대상이지만 molds 에 없는 금형. 본사 3역할 전용.
  <Route key="pc-as-molds" path="as-molds" element={
    <ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><AsMoldRegistryPage /></ProtectedRoute>
  } />,
  <Route key="pc-admin-partner-ops" path="dashboard/system-admin/partner-operations" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff', 'plant', 'maker']}><PartnerOperationsPage /></ProtectedRoute>} />,

  <Route key="pc-admin-audit" path="dashboard/system-admin/audit-logs" element={<ProtectedRoute allowedRoles={['system_admin']}><AuditLogPage /></ProtectedRoute>} />,

  /* 기존 경로 호환 */

  <Route key="pc-compat-admin" path="dashboard/admin" element={<ProtectedRoute allowedRoles={['system_admin']}><SystemAdminDashboard /></ProtectedRoute>} />,

  <Route key="pc-compat-dev" path="dashboard/developer" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><MoldDeveloperDashboard /></ProtectedRoute>} />,

  <Route key="pc-m-maker" path="mobile/maker" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff', 'maker']}><MakerMobileDashboard /></ProtectedRoute>} />,

  <Route key="pc-m-plant" path="mobile/plant" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff', 'plant']}><PlantMobileDashboard /></ProtectedRoute>} />,

  <Route key="pc-m-dev" path="mobile/developer" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><DeveloperMobileDashboard /></ProtectedRoute>} />,

  /* 금형 */

  <Route key="pc-molds" path="molds" element={<MoldList />} />,

  <Route key="pc-mold-new" path="molds/new" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer']}><MoldNew /></ProtectedRoute>} />,

  <Route key="pc-mold-reg" path="molds/register" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer']}><MoldRegistration /></ProtectedRoute>} />,

  // Phase JZ-104 M-2: 금형 일괄 업로드 — admin/dev 만 (Mobile mold-new ADMIN_DEV 페어)
  <Route key="pc-mold-bulk" path="molds/bulk-upload" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer']}><MoldBulkUpload /></ProtectedRoute>} />,

  // Phase JZ-104 M-3: 금형 마스터 편집 — admin/dev/staff 만 (협력사 차단)
  <Route key="pc-mold-master" path="molds/master" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><MoldMaster /></ProtectedRoute>} />,

  <Route key="pc-mold-life" path="molds/lifecycle" element={<MoldLifecycle />} />,

  <Route key="pc-mold-spec" path="molds/specifications/:id" element={<MoldDetailNew />} />,

  <Route key="pc-mold-detail" path="molds/detail/:id" element={<MoldDetailNew />} />,

  <Route key="pc-mold-id" path="molds/:id" element={<MoldDetailNew />} />,

  <Route key="pc-mold-docs" path="molds/:id/documents" element={<MoldDocuments />} />,

  <Route key="pc-mold-photos" path="molds/:id/photos" element={<MoldPhotoGallery />} />,

  /* 점검 */

  // Phase JZ-104 H-1: 일상점검 INSPECTOR_ROLES (Mobile 페어 — maker 차단, Phase BI 거버넌스)
  <Route key="pc-daily" path="checklist/daily" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff', 'plant']}><DailyChecklist /></ProtectedRoute>} />,

  // Phase JZ-104 H-2: 정기점검 INSPECTOR_ROLES (습합/세척 포함 — maker 차단)
  <Route key="pc-periodic" path="inspection/periodic" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff', 'plant']}><PeriodicInspection /></ProtectedRoute>} />,

  // Phase JZ-104 H-3: 점검 승인 APPROVER_ROLES (본사 전용 — plant/maker 차단)
  <Route key="pc-insp-appr" path="inspection-approval" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><InspectionApproval /></ProtectedRoute>} />,

  // Phase JZ-108: 체크리스트 마스터 — admin/dev/staff 만 (협력사 차단, 마스터 편집 영역)
  <Route key="pc-cl-master" path="checklist-master" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><ChecklistMaster /></ProtectedRoute>} />,

  <Route key="pc-cl-master2" path="checklist/master" element={<MoldChecklist />} />,

  <Route key="pc-mold-cl" path="mold-checklist" element={<MoldChecklist />} />,

  /* 이관 */

  <Route key="pc-transfers" path="transfers" element={<TransferManagement />} />,

  <Route key="pc-transfer-new" path="transfers/new" element={<TransferRequest />} />,

  /* 수리 */

  <Route key="pc-repairs" path="repairs" element={<RepairManagement />} />,

  <Route key="pc-repair-new" path="repairs/new" element={<RepairRequestForm />} />,

  <Route key="pc-repair-ship" path="repairs/shipment-checklist" element={<RepairShipmentChecklist />} />,
  // 출하체크리스트 상세 — 대시보드 위젯 링크
  <Route key="pc-repair-ship-id" path="repair-shipment-checklist/:id" element={<RepairShipmentChecklist />} />,

  <Route key="pc-repair-form" path="repair-request-form" element={<RepairRequestForm />} />,

  <Route key="pc-hq-repair" path="hq/repair-requests" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer']}><HqRepairListPage /></ProtectedRoute>} />,

  <Route key="pc-maker-repair" path="maker/repair-requests" element={<ProtectedRoute allowedRoles={['maker']}><MakerRepairListPage /></ProtectedRoute>} />,
  // /maker/repairs alias — MakerDashboard "전체 보기" 링크
  <Route key="pc-maker-repair-alias" path="maker/repairs" element={<ProtectedRoute allowedRoles={['maker']}><MakerRepairListPage /></ProtectedRoute>} />,

  <Route key="pc-mold-repair-history" path="mold-repair-history" element={<MoldRepairHistory />} />,
  <Route key="pc-mold-transfer-history" path="mold-transfer-history" element={<MoldTransferHistory />} />,
  // Phase BD: 점검 결과 이력관리
  <Route key="pc-mold-inspection-history" path="molds/:moldId/inspection-history" element={<MoldInspectionHistory />} />,

  // 2026-07-08 orphan 정리: PC 배선 복원 — 모바일 페어(/mobile/over-shot-molds, /mobile/inspection-due-molds)와 동일 무가드 (백엔드 /hq/molds/* 격리 의존)
  <Route key="pc-overshot" path="over-shot-molds" element={<OverShotMoldListPage />} />,
  <Route key="pc-insp-due" path="inspection-due-molds" element={<InspectionDueMoldListPage />} />,

  // Phase JZ-104 H-4: 제작처 금형상세 — admin 전체 열람 + maker 자사 (plant 차단)
  <Route key="pc-maker-mold" path="maker/mold/:id" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff', 'maker']}><MakerMoldDetail /></ProtectedRoute>} />,

  /* 금형 개발 */

  <Route key="pc-dev-plan" path="mold-development/plan" element={<MoldDevelopmentPlan />} />,

  <Route key="pc-nurturing" path="mold-development/nurturing" element={<MoldNurturingPage />} />,

  // 2026-06-16 신규: 차종별 금형문제점 개선현황 (캠스 담당자 전용 — 사용자 명시)
  <Route key="pc-nurturing-overview" path="mold-development/nurturing-overview" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><MoldNurturingOverview /></ProtectedRoute>} />,

  <Route key="pc-hardness" path="mold-development/hardness" element={<HardnessMeasurement />} />,

  <Route key="pc-spec" path="mold-specification" element={<MoldSpecification />} />,

  <Route key="pc-spec-id" path="mold-specification/:id" element={<MoldSpecification />} />,

  // M2 Task 7: 성형해석 검증 (molding-engine 수동입력 모드 + 계산 결과)
  <Route key="pc-molding-analysis" path="molding-analysis" element={<MoldingAnalysis />} />,

  // 투자비 관리 — 2026-10-02 사용자 결정: **관리자(system_admin) 전용**
  // ⚠ 협력사(plant/maker)뿐 아니라 담당자(mold_developer/staff)도 라우트·페이지·서버 3중으로 차단된다.
  <Route key="pc-mold-investment" path="mold-investment" element={
    <ProtectedRoute allowedRoles={['system_admin']}><MoldInvestment /></ProtectedRoute>
  } />,

  /* 사출 */

  <Route key="pc-inj-hist" path="injection-history" element={<InjectionHistory />} />,

  <Route key="pc-inj-stat" path="injection-stats" element={<InjectionStats />} />,

  <Route key="pc-inj-cond" path="injection-condition" element={<InjectionCondition />} />,

  /* 협력사 관리 */

  <Route key="pc-partner-companies" path="partner-management/companies" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer']}><CompanyManagement /></ProtectedRoute>} />,

  // Phase JZ-105: 협력사 사출기 보유현황 통계 — admin/dev/staff 만 (전사 통계 격리)
  <Route key="pc-partner-injection" path="partner-management/injection-machines" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><PartnerInjectionSummary /></ProtectedRoute>} />,

  // Phase JZ-105: 협력사 일반장비 통계 — admin/dev/staff 만
  <Route key="pc-partner-equipment" path="partner-management/equipment" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><PartnerEquipmentSummary /></ProtectedRoute>} />,

  // Phase JZ-105: 협력사 도장라인 통계 — admin/dev/staff 만
  <Route key="pc-partner-paintline" path="partner-management/paint-lines" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><PartnerPaintLineSummary /></ProtectedRoute>} />,

  /* Phase EP: 대시보드/메뉴 alias — 짧은 경로도 동일 컴포넌트 노출 */
  <Route key="pc-partner-users-alias" path="partner-users" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer']}><PartnerUsers /></ProtectedRoute>} />,
  // Phase JZ-105: 협력사 통계 alias 3건 — 동일 가드 (admin/dev/staff)
  <Route key="pc-partner-inj-alias" path="partner-injection-summary" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><PartnerInjectionSummary /></ProtectedRoute>} />,
  <Route key="pc-partner-eq-alias" path="partner-equipment-summary" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><PartnerEquipmentSummary /></ProtectedRoute>} />,
  <Route key="pc-partner-paint-alias" path="partner-paintline-summary" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><PartnerPaintLineSummary /></ProtectedRoute>} />,

  /* 회사/사용자 */

  <Route key="pc-companies" path="companies" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer']}><CompanyManagement /></ProtectedRoute>} />,

  <Route key="pc-company-id" path="companies/:id" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer']}><CompanyDetail /></ProtectedRoute>} />,

  <Route key="pc-company-profile" path="company-profile" element={<ProtectedRoute allowedRoles={['maker', 'plant']}><CompanyProfile /></ProtectedRoute>} />,

  <Route key="pc-plant-sel" path="plant/select-mold/:task" element={<ProtectedRoute allowedRoles={['plant']}><PlantMoldSelect /></ProtectedRoute>} />,

  <Route key="pc-user-req" path="user-requests" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer']}><UserRequests /></ProtectedRoute>} />,

  <Route key="pc-master-data" path="master-data" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><MasterData /></ProtectedRoute>} />,
  // 2026-11-02 점검관리 마스터 — 자사 담당자 이상 (협력사 접근 불가, 사용자 명시 정책)
  <Route key="pc-inspection-master" path="inspection-master" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><InspectionGuideMaster /></ProtectedRoute>} />,

  <Route key="pc-users-int" path="users/internal" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer']}><InternalUsers /></ProtectedRoute>} />,

  <Route key="pc-users-part" path="users/partner" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer']}><PartnerUsers /></ProtectedRoute>} />,

  /* 통합관리 */

  <Route key="pc-workflow" path="workflow" element={<MoldWorkflowManagement />} />,

  <Route key="pc-alerts" path="alerts" element={<Alerts />} />,
  <Route key="pc-alert-detail" path="alerts/detail/:id" element={<AlertDetail />} />,

  <Route key="pc-notifs" path="notifications" element={<Alerts />} />,

  <Route key="pc-notif-set" path="notification-settings" element={<NotificationSettings />} />,

  /* 체크리스트 마스터 — 레거시 경로는 StandardDocumentMaster 로 통합 (리다이렉트) */
  <Route key="pc-precheck" path="pre-production-checklist" element={<Navigate to="/standard-document-master" replace />} />,
  <Route key="pc-cl-detail" path="checklist-master/:id" element={<Navigate to="/standard-document-master" replace />} />,
  <Route key="pc-cl-edit" path="checklist-master/:id/edit" element={<Navigate to="/standard-document-master" replace />} />,

  /* 폐기/유지보전 */

  // 2026-06-22: 단독 폐기 목록(/scrapping)은 통합관리(금형폐기)와 중복 → 통합관리로 단일화
  <Route key="pc-scrap" path="scrapping" element={<Navigate to="/workflow?tab=scrapping" replace />} />,

  // 2026-06-19: 금형별 폐기 진행현황 (scrapping/:id 보다 먼저 — 'progress' 매칭 우선)
  <Route key="pc-scrap-progress" path="scrapping/progress" element={<MoldScrappingProgress />} />,

  <Route key="pc-scrap-id" path="scrapping/:id" element={<ScrappingManagement />} />,

  <Route key="pc-maint" path="maintenance" element={<MaintenanceManagement />} />,

  <Route key="pc-maint-id" path="maintenance/:id" element={<MaintenanceManagement />} />,

  /* 통계/리포트 */

  // Phase JZ-104 H-5: 리포트 — admin/dev/staff 만 (협력사 차단 — 전사 통계 격리)
  <Route key="pc-reports" path="reports" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><Reports /></ProtectedRoute>} />,

  // Phase JZ-108: 리포트 탭 alias — admin/dev/staff (Phase JZ-104 H-5 /reports 정합)
  <Route key="pc-reports-tab" path="reports/:tab" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff']}><Reports /></ProtectedRoute>} />,

  /* 금형 이력/QR */

  // 금형이력: admin/dev/staff + 협력사(plant/maker) — 협력사는 백엔드 회사 격리로 자사 금형만
  //   (2026-06-14 plant/maker 비활성화 → 사용자 요청으로 재개방. IDOR 은 서버 assertCompanyScope/회사필터 강제)
  <Route key="pc-hist" path="mold-history" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff', 'plant', 'maker']}><MoldHistory /></ProtectedRoute>} />,

  // 변경이력 상세 alias — 동일 가드
  <Route key="pc-hist-id" path="mold-history/:id" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff', 'plant', 'maker']}><MoldHistory /></ProtectedRoute>} />,

  <Route key="pc-qrcode" path="mold-qrcode" element={
    <ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff', 'maker']}>
      <MoldQRCode />
    </ProtectedRoute>
  } />,

  <Route key="pc-qr-sess" path="qr-sessions" element={<ProtectedRoute allowedRoles={['system_admin']}><QRSessionsPage /></ProtectedRoute>} />,

  <Route key="pc-loc-map" path="mold-location-map" element={<MoldLocationMapPage />} />,
  // /mold-locations alias — MoldDeveloperDashboard "금형 위치 관리" 메뉴
  <Route key="pc-mold-locations" path="mold-locations" element={<MoldLocationMapPage />} />,

  /* 표준문서 */

  <Route key="pc-std-doc" path="standard-document-master" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer']}><StandardDocumentMaster /></ProtectedRoute>} />,

  <Route key="pc-doc-console" path="document-master-console" element={<Navigate to="/standard-document-master" replace />} />,

  <Route key="pc-pt-master" path="production-transfer/checklist-master" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer']}><ProductionTransferChecklistMaster /></ProtectedRoute>} />,

  // 양산처이관 — 금형상세 서브페이지 (제작처 작성/제출 → 본사 승인)
  <Route key="pc-pt-checklist" path="production-transfer/checklist" element={<ProtectedRoute allowedRoles={['system_admin', 'mold_developer', 'staff', 'maker', 'plant']}><ProductionTransferChecklist /></ProtectedRoute>} />,

]

